import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import PublicHeader from "@/components/PublicHeader";
import { api, errMsg } from "@/lib/api";

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const [state, setState] = useState({ status: "working", msg: "Updating your email preferences…" });
  const done = useRef(false);
  useEffect(() => {
    if (done.current) {
      return;
    }
    done.current = true;
    const token = params.get("token") || "";
    if (token.length < 20) {
      setState({ status: "error", msg: "This unsubscribe link is incomplete. You can manage emails in your Privacy center." });
      return;
    }
    api.post("/email/unsubscribe", { token })
      .then(({ data }) => setState({ status: "ok", msg: `You're unsubscribed from "${data.label}". Security emails like password resets will still be sent.` }))
      .catch((e) => setState({ status: "error", msg: errMsg(e) }));
  }, [params]);
  return (
    <div className="min-h-screen"><PublicHeader />
      <main className="mx-auto max-w-lg px-4 py-24 text-center">
        <h1 className="text-3xl font-extrabold" data-testid="unsubscribe-title">Email preferences</h1>
        <p className={`mt-4 ${state.status === "error" ? "text-red-600" : "text-slate-600"}`} data-testid="unsubscribe-message">{state.msg}</p>
        <Button asChild variant="outline" className="mt-8 rounded-full" data-testid="unsubscribe-manage-link"><Link to="/app/privacy">Manage all preferences</Link></Button>
      </main>
    </div>
  );
}
